import React from "react";
import { Dialog, FlatButton, TextField, Checkbox } from "material-ui";
import Select from "react-select";

import Label from "./label.jsx";
import InfoNotice from "./info-notice.jsx";

const USER_SHOULD_SET_PASSWORD = "USER_SHOULD_SET_PASSWORD";
const PASSWORD_PLACEHOLDER = "•••••••••";

class AccountEditorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {}
    };

    this.onRequestClose = this.onRequestClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  getStyles() {
    return {
      container: {
        margin: "15px 0"
      },
      inputContainer: {
        textAlign: "left",
        margin: "0 auto",
        maxWidth: "90%",
        width: 256
      },
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }

  onRequestClose() {
    this.props.onCancel();
  }

  onSave() {
    this.props.onSave(this.state.values);
  }

  onChangeValue(id, value) {
    let { values } = this.state;
    values[id] = value;
    this.setState({ values });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    let account = newProps.account || {};

    this.setState({
      values: {
        name: account.name,
        email: account.email,
        password: newProps.isNew ? USER_SHOULD_SET_PASSWORD : "",
        role: account.role || "admin"
      }
    });
  }

  render() {
    let styles = this.getStyles(),
      { roles } = this.props;

    return (
      <Dialog
        title={this.props.isNew ? "Create account" : "Edit account"}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        openImmediately={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={this.onRequestClose} />,
          <FlatButton primary={true} label="Save" onTouchTap={this.onSave} />
        ]}
        modal={true}
        open={true}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        bodyStyle={{ overflowY: "visible" }}
        onRequestClose={this.onRequestClose}
      >
        <form autoComplete="off" style={{ width: 256, margin: "0 auto" }}>
          <div>
            <TextField
              value={this.state.values.name}
              floatingLabelText="Name"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              value={this.state.values.email}
              floatingLabelText="Email address"
              floatingLabelFixed={true}
              type="email"
              autoComplete="username email"
              onChange={e => this.onChangeValue("email", e.target.value)}
            />
          </div>
          <div>
            {this.props.isNew ? (
              <div>
                <Label>Password</Label>
                <Checkbox
                  label="Send link for account holder to set"
                  style={{ fontSize: "0.75em" }}
                  checked={
                    this.state.values.password === USER_SHOULD_SET_PASSWORD
                  }
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "password",
                      checked ? USER_SHOULD_SET_PASSWORD : ""
                    )
                  }
                />
              </div>
            ) : null}
            {this.state.values.password !== USER_SHOULD_SET_PASSWORD ? (
              <TextField
                value={this.state.values.password}
                hintText={PASSWORD_PLACEHOLDER}
                floatingLabelFixed={true}
                floatingLabelText={!this.props.isNew && "Password"}
                type="password"
                autoComplete="new-password"
                onChange={e => this.onChangeValue("password", e.target.value)}
              />
            ) : null}
          </div>
          <div>
            <Label>Role</Label>
            <Select
              clearable={false}
              value={this.state.values.role}
              options={Object.keys(roles).map(k => {
                return {
                  label: roles[k].label,
                  value: k
                };
              })}
              onChange={e => this.onChangeValue("role", e ? e.value : "")}
            />
            <InfoNotice style={{ marginTop: "1em", fontSize: "10pt" }}>
              Check out our{" "}
              <a
                href="https://help.eventive.org/en/articles/5971421-explanation-of-roles-and-permissions"
                target="_blank"
              >
                guide to roles and permissions
              </a>
              .
            </InfoNotice>
          </div>
        </form>
      </Dialog>
    );
  }
}

export default AccountEditorModal;



// WEBPACK FOOTER //
// ./src/app/components/partials/account-editor-modal.jsx